// extracted by mini-css-extract-plugin
export default {"skeleton":"Skeleton_skeleton__uk9vz","shine":"Skeleton_shine__ngVW6"};